module.exports = __webpack_public_path__ + "img/contest_bg_img.5bde56e0.png";